/**
 *
 *
 *
 */
class TCModelError extends Error {
    /**
 *
 *
 *
 *
 *
 */
    constructor(fieldName, passedValue, msg = '') {
        super(`invalid value ${passedValue} passed for ${fieldName} ${msg}`);
        this.name = 'TCModelError';
    }
}
export { TCModelError };
